<div class="paper client-info-section">
  <app-client-info-section-item
    label="User Name:"
    [value]="clientFullName"
    [isLoading]="isLoading"
  ></app-client-info-section-item>

  <app-client-info-section-item
    label="Primary Fax Nbr:"
    [value]="primaryClientNumber"
    [isLoading]="isLoading"
  ></app-client-info-section-item>

  <app-client-info-section-item
    label="Company Number:"
    [value]="safeClientProfileInfo.phoneNumber"
    [isLoading]="isLoading"
  ></app-client-info-section-item>

  <app-client-info-section-item
    label="Company Name:"
    [value]="safeClientProfileInfo.companyName"
    [isLoading]="isLoading"
  ></app-client-info-section-item>
</div>
